import { ApiService, CustomHttpParams } from '@abb-procure/api';
import { Injectable } from '@angular/core';
import { RequestForQuotationSupplierResponseModel } from '../models/request-for-quotation-supplier-response.model';
import { PaginatedRequest } from '../types/paginated-request.type';
import { RequestForQuotationSupplierResponse } from '../types/request-for-quotation-supplier-response.type';

@Injectable({
  providedIn: 'root',
})
export class RequestForQuotationLookupApiService extends ApiService {
  async getRequestForQuotationsBySupplier(
    supplierId: string,
    requestForQuotationRequest: PaginatedRequest,
  ): Promise<RequestForQuotationSupplierResponseModel | null> {
    try {
      const queryParams = new CustomHttpParams(requestForQuotationRequest);

      const response = await this.get<RequestForQuotationSupplierResponse>(
        `supplier/${supplierId}/rfq`,
        RequestForQuotationSupplierResponse,
        queryParams,
      );

      return response != null
        ? new RequestForQuotationSupplierResponseModel(response)
        : null;
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue retrieving the list of Request for Quotation items.',
      );
    }
  }
}
